import '../css/terms.css';

export default function FAQ() {
    const zoopId = [
        { id: 0, title: 'What is ZoopID?', desc: `ZoopID is the latest offering for Zoop.One for Digital India, it’s One Identity Platform where every individual can store their personal identification data and documents securely and (re)use them for availing various services.` },
        { id: 1, title: 'What services can be availed on ZoopID?', desc: `While many services will be added in the near future, currently, users can apply for short instant loans via ZoopID. ZoopID has partnered with various lenders so that loan(s) can be applied very quickly. Users can check which loan they can apply for. (Please note that ZoopID does not provide any loans)` },
        { id: 2, title: 'What is the support email?', desc: `ZoopID support email is hi@zoop.one`}
    ];
    const docWallet = [
        { id: 0, title: 'What is Docuwallet', desc: `Docuwallet is an integral part of ZoopID where users can store their personal documents like AADHAAR, PAN and Driving License easily and securely.` },
        { id: 1, title: 'What documents can be stored in Docuwallet?', desc: `Users can upload documents via image capture via device camera only. Please follow the document upload process for precise information.` },
        { id: 2, title: 'Do users need to provide any consent(s) for storing and sharing the documents stored on ZoopID?', desc: `Yes, ZoopID makes sure that Users are in control of their documents and hence, before uploading/ storing and sharing any document(s), ZoopID requests for a consent from the users, so as to keep them informed about their actions.` },
        { id: 3, title: 'How are these documents stored in Docuwallet?', desc: `ZoopID essentially does not store any documents on its server, all the documents are stored on users’ local devices (for instance - smartphones), so that the user is in control of her/ his data and information` },
        { id: 4, title: 'Can Users delete any stored documents in Docuwallet?', desc: `While we do not encourage deleting any personal documents, Yes, users can delete any documents they have stored in Docuwallet. Please note that users will lose all the access to those documents and will need to upload these deleted documents again` },
    ];
    const instantLoans = [
        { id: 0, title: 'What loans are available on ZoopID?', desc: `ZoopID is constantly adding new types of loans. Currently, we have partnered with the best short term instant loan providers, to facilitate instant loans for our users` },
        { id: 1, title: 'How can users apply for Short Instant loans via ZoopID?', desc: `Users need to enter specific information related to their personal, location, financial and other details to create a profile. This profile is used to push best loan offerings for users. Users can select any lender of their choice and submit a few details to check their eligibility.` },
    ];
    return (
        <div class="terms-and-condition-wrp">
            {/* <div class="header">
                <div class="title-header">
                    <h4>
                        FAQ
                    </h4>
                </div>
                <p>
                    Zoop whereabouts
                </p>
            </div> */}
            <div class="content">
                <h2>ZoopID</h2>
                {zoopId.map(opt => (
                    <div class="content-block" key={opt.id}>
                        <p class="content-title">{opt.title}</p>
                        <p class="content-detail">{opt.desc}</p>
                    </div>
                ))}
                 <h2>Documents, Docuwallet and ZoopID</h2>
                {docWallet.map(opt => (
                    <div class="content-block" key={opt.id}>
                        <p class="content-title">{opt.title}</p>
                        <p class="content-detail">{opt.desc}</p>
                    </div>
                ))}
                <h2>Short Instant Loans and ZoopID</h2>
                {instantLoans.map(opt => (
                    <div class="content-block" key={opt.id}>
                        <p class="content-title">{opt.title}</p>
                        <p class="content-detail">{opt.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}